import React from 'react'
import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { Typography, Space } from 'antd'
import { TwitterCircleFilled } from '@ant-design/icons'

const { Paragraph } = Typography

const style = {
  gradient: css`
    background: linear-gradient(90deg, @SF-grad-l-yellow, @SF-grad-l-blue);
  `,

  container: css`
    width: 100%;
    text-align: center;
    padding: 20px;
    border-top: 1px solid @SF-background-border;
    padding: 30px;
  `,
  wrapper: css`
    display: grid;
    grid-template-columns: auto 10rem;
    grid-template-rows: auto;
    margin: 0 auto;
    max-width: 960px;
    padding: 1.45rem 1.0875rem;
  `,
  title: css`
    margin: 0;
    display: inline-block;
  `
}

const FooterLink = styled.a`
  color: #fff;
  white-space: nowrap;

  &:active,
  &:hover {
    color: #fff;
  }
`

export const Footer = () => {
  return (
    <div css={style.container} className="sf-reverse-gradient">
      <img
        src="https://ik.imagekit.io/stayfari/general/tr:w-116,h-116/tripadvisor-recommended_nhYA6htLW.png?ik-sdk-version=javascript-1.4.3&updatedAt=1666155396769"
        alt="Recommended on TripAdvisor"
        width="116"
        height="116"
      />
      {/* <Paragraph> */}
      {/* <svg><use xlink:href="assets/sprites/icons.svg#icon-facebook"></use></svg> */}
      {/* <TwitterCircleFilled /> */}
      {/* </Paragraph> */}
      <Paragraph>
        <Space>
          <FooterLink target="_blank" href="https://www.stayfari.com/terms">
            Terms
          </FooterLink>
          <FooterLink target="_blank" href="https://www.stayfari.com/privacy">
            Privacy
          </FooterLink>
          <FooterLink target="_blank" href="https://www.stayfari.com/about">
            About us
          </FooterLink>
          <FooterLink target="_blank" href="https://www.stayfari.com/pricing">
            Pricing
          </FooterLink>
          <FooterLink target="_blank" href="https://www.stayfari.com/contact">
            Contact us
          </FooterLink>
          <FooterLink href="https://www.stayfari.com/blog">Blog</FooterLink>
        </Space>
      </Paragraph>
      <Paragraph>© {new Date().getFullYear()} Stayfari India Private Limited</Paragraph>
    </div>
  )
}
